/*
 * This file can be replaced during build by using the `fileReplacements` array.
 * `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
 * The list of file replacements can be found in `angular.json`.
 */

export const environment = {
  environmentName: "dev",
  production: false,
  categories: "abcat*",
  searchBar: false,
  s3bucket: "https://basiliskbooking2f57e388900b4cc7b6bbab95ec991a961dc78-dev.s3.amazonaws.com/public/",
  // Stripe configuration
  stripePublishableKey: 'pk_test_51PayCxErmUoa3YG5gxHRsIklMHM1BsHbccYyuIgQJYtlzupMrlM0HMq9UG3jZHl0m0V8sKiu52LQjuv4E8m04BdI0050tL5Ddf',
  stripeApiUrl: 'https://api.stripe.com/v1', // Stripe API URL (for reference)
  // NOTE: Stripe Secret Key is stored securely in AWS Secrets Manager
  // It is NEVER exposed in frontend code or committed to version control
  backendApiUrl: 'http://localhost:3000/api/stripe', // TODO: Replace with your backend API URL for Stripe operations
  // Stripe function URL - will be automatically populated from amplify_outputs.json after deployment
  // You can manually set this if needed for local testing
  stripeFunctionUrl: '' // Leave empty to auto-detect from amplify_outputs.json

  // Optional: Override or extend domain → location mapping for multi-site (see domain-location.config.ts)
  // domainToLocationMap?: Record<string, string>;
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
